{
  const adjustPadding = bar => {
    if (window.innerWidth <= 1024) return
    const noteBar = bar.querySelector('.utility-bar--note-bar')
    const sibling = bar.nextElementSibling
    if (!sibling?.classList.contains('acf-style-vars')) return

    if (!sibling.dataset.utilityBarBasePaddingTop) {
      sibling.dataset.utilityBarBasePaddingTop = parseInt(getComputedStyle(sibling).getPropertyValue('--padding-top')) || 0
    }

    const base = parseInt(sibling.dataset.utilityBarBasePaddingTop) || 0
    const noteHeight = (noteBar && getComputedStyle(noteBar).display !== 'none') ? noteBar.offsetHeight : 0
    sibling.style.setProperty('--padding-top', ((base * 2) + noteHeight) + 'px')
  }

  document.querySelectorAll('.utility-bar').forEach(bar => {
    const hoursEl   = bar.querySelector('.utility-bar--hours')
    const noteBarEl = bar.querySelector('.utility-bar--note-bar')
    if (!hoursEl) return

    adjustPadding(bar)
    window.addEventListener('resize', () => adjustPadding(bar))

    // In preview mode the server-rendered content is authoritative — skip AJAX
    const previewDt = bar.getAttribute('data-preview-datetime')
    if (previewDt) return

    window.coolHelperFunctions?.coolAjax({ action: 'utility_bar_hours' }, res => {
      if (res?.data?.hours_html) hoursEl.innerHTML = res.data.hours_html
      const note = res?.data?.note_html || ''
      bar.querySelectorAll('.utility-bar--note-bar').forEach(el => {
        el.innerHTML = note
        el.style.display = note ? '' : 'none'
      })
      adjustPadding(bar)
    })
  })
}
